import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Card } from "react-bootstrap";
import classNames from "classnames";
import { getDownloadURL, getStorage, ref } from "firebase/storage";

import Background from "../common/Background";
import Avatar from "../common/Avatar";
import dummyAvatar from "../../assets/img/team/2.jpg";

const ProfileBannerHeader = ({ avatar, className }) => {
	const [urlImg, setUrlImg] = useState("");

	const getImgUrl = (url) => {
		const urlTmp = url.slice(0, 5);
		if (urlTmp === "https") {
			setUrlImg(url);
		} else {
			const storage = getStorage();
			const imgRef = ref(storage, url);

			getDownloadURL(imgRef)
				.then((URL) => {
					setUrlImg(URL);
					return URL;
				})
				.catch((error) => {
					setUrlImg(dummyAvatar);
					return dummyAvatar;
				});
		}
	};
	useEffect(() => {
		avatar !== "" && getImgUrl(avatar);
	}, [avatar]);
	return (
		<Card.Header
			className={classNames(className, "position-relative min-vh-25 mb-7")}>
			<Background
				solidColor={"#e1e1e1"}
				className="rounded-3 rounded-bottom-0"
			/>

			{urlImg ? (
				<Avatar
					size="5xl"
					className="avatar-profile"
					src={urlImg}
					onError={()=>setUrlImg(dummyAvatar)}
					mediaClass="img-thumbnail shadow-sm"
				/>
			) : (
				<Avatar
					size="5xl"
					className="avatar-profile"
					src={dummyAvatar}
					mediaClass="img-thumbnail shadow-sm"
				/>
			)}
		</Card.Header>
	);
};

const ProfileBannerBody = ({ children }) => {
	return <Card.Body>{children}</Card.Body>;
};

const ProfileBanner = ({ children }) => {
	return <Card className="mb-3">{children}</Card>;
};

ProfileBanner.Header = ProfileBannerHeader;
ProfileBanner.Body = ProfileBannerBody;

ProfileBannerHeader.propTypes = {
	avatar: PropTypes.string.isRequired,
	coverSrc: PropTypes.string.isRequired,
	className: PropTypes.string,
};

ProfileBannerBody.propTypes = {
	children: PropTypes.node.isRequired,
};

ProfileBanner.propTypes = {
	children: PropTypes.node.isRequired,
};

export default ProfileBanner;
